/* razeco theme — Logik nach "razeco Prototyp.dc.html" */
(function () {
  'use strict';

  var RZ = window.RZ = window.RZ || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- Money */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || RZ.moneyFormat || '{{amount_with_comma_separator}} €';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  RZ.money = function (c) { return formatMoney(c); };
  var eur = RZ.money;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------- Rhythmus */
  // Selling-Plan-Name → Monate ("Lieferung alle 3 Monate", "Every 2 months", "alle 8 Wochen")
  // "Alle 2 Monate liefern, 19,99 €" → 2 · "Jeden Monat liefern, 19,99 €" → 1 · "3-month" → 3 · "alle 8 Wochen" → 2
  function planMonths(name) {
    if (!name) return null;
    var s = String(name).toLowerCase();
    var m = s.match(/(\d+)[\s-]*(monat|month|woche|week)/);
    if (m) {
      var n = parseInt(m[1], 10);
      return /^w/.test(m[2]) ? Math.max(1, Math.round(n / 4.345)) : n;
    }
    if (/jede[nrs]?\s+monat|every\s+month|monthly|monatlich/.test(s)) return 1;
    return null;
  }
  function rhythmLabel(months) { return Number(months) === 1 ? 'jeden Monat' : 'alle ' + months + ' Monate'; }
  RZ.rhythmLabel = rhythmLabel;

  /* -------------------------------------------------------- Produktmodell */
  // Fallback-Daten aus dem Prototyp — damit das Theme ohne verknüpfte Produkte korrekt aussieht.
  var DEMO_PACKS = { 5: { reg: 1749, abo: 1499 }, 10: { reg: 3499, abo: 2749 }, 20: { reg: 5999, abo: 4999 } };
  var DEMO_MONTHS = [2, 3, 4, 6];
  function demoRefills() {
    var variants = [];
    ['face', 'body'].forEach(function (g) {
      [5, 10, 20].forEach(function (n) {
        variants.push({
          id: null, title: g + ' / ' + n + 'er', options: [g, n + 'er'], price: DEMO_PACKS[n].reg, compareAtPrice: 0, available: true, image: null,
          plans: DEMO_MONTHS.map(function (m) { return { id: null, name: rhythmLabel(m), price: DEMO_PACKS[n].abo }; })
        });
      });
    });
    return { demo: true, handle: '', title: 'refills', options: ['Variante', 'Packung'], groups: [], variants: variants };
  }
  function demoKit() {
    var variants = [];
    ['face', 'body'].forEach(function (g) {
      variants.push({ id: null, title: g + ' / einmalig', options: [g, 'einmalig'], price: 1499, compareAtPrice: 0, available: true, plans: [] });
      variants.push({ id: null, title: g + ' / mit Klingen-Abo', options: [g, 'mit Klingen-Abo'], price: 999, compareAtPrice: 0, available: true, plans: [] });
    });
    return { demo: true, handle: '', title: 'razeco5 starterkit', options: ['Griff', 'Kaufart'], groups: [], variants: variants };
  }

  function Product(data) {
    this.data = data;
    this.variants = data.variants || [];
    var opts = data.options || [];
    var self = this;
    this.modeIdx = -1; this.packIdx = -1; this.gripIdx = -1;
    opts.forEach(function (name, i) {
      var vals = self.values(i);
      if (self.modeIdx < 0 && (/kaufart|purchase|kauf/i.test(name) || vals.some(function (v) { return /abo/i.test(v); }))) self.modeIdx = i;
    });
    opts.forEach(function (name, i) {
      if (i === self.modeIdx) return;
      var vals = self.values(i);
      if (self.packIdx < 0 && vals.length && vals.every(function (v) { return /\d/.test(v); })) self.packIdx = i;
    });
    opts.forEach(function (name, i) {
      if (i === self.modeIdx || i === self.packIdx) return;
      if (self.gripIdx < 0) self.gripIdx = i;
    });
  }
  Product.prototype.values = function (i) {
    var seen = [];
    this.variants.forEach(function (v) { var x = v.options[i]; if (x != null && seen.indexOf(x) < 0) seen.push(x); });
    return seen;
  };
  Product.prototype.grips = function () { return this.gripIdx < 0 ? [] : this.values(this.gripIdx); };
  Product.prototype.packs = function () {
    if (this.packIdx < 0) return [];
    return this.values(this.packIdx).map(function (v) { return { value: v, n: parseInt(v.match(/\d+/)[0], 10) }; })
      .sort(function (a, b) { return a.n - b.n; });
  };
  function eqi(a, b) { a = String(a).toLowerCase(); b = String(b).toLowerCase(); return a === b || a.indexOf(b) >= 0; }
  Product.prototype.find = function (q) {
    var self = this;
    var list = this.variants.filter(function (v) {
      if (q.grip != null && self.gripIdx >= 0 && !eqi(v.options[self.gripIdx], q.grip)) return false;
      if (q.pack != null && self.packIdx >= 0 && parseInt((v.options[self.packIdx].match(/\d+/) || [0])[0], 10) !== Number(q.pack)) return false;
      if (q.abo != null && self.modeIdx >= 0 && (/abo/i.test(v.options[self.modeIdx]) !== !!q.abo)) return false;
      return true;
    });
    return list[0] || null;
  };
  Product.prototype.planFor = function (variant, months) {
    if (!variant || !variant.plans || !variant.plans.length) return null;
    var hit = null;
    variant.plans.forEach(function (p) { if (!hit && planMonths(p.name) === Number(months)) hit = p; });
    return hit || variant.plans[0];
  };
  Product.prototype.months = function () {
    var seen = [];
    this.variants.forEach(function (v) {
      (v.plans || []).forEach(function (p) { var m = planMonths(p.name); if (m && seen.indexOf(m) < 0) seen.push(m); });
    });
    return seen.sort(function (a, b) { return a - b; });
  };
  // Preis einer Packung (Klingen) für Griff, Größe, Kaufart und Rhythmus
  Product.prototype.offer = function (grip, pack, abo, months) {
    var v = this.find({ grip: grip, pack: pack });
    if (!v) return null;
    var plan = abo ? this.planFor(v, months) : null;
    return { variant: v, plan: plan, price: plan ? plan.price : v.price, reg: v.price, n: Number(pack) };
  };

  // Abo-Pläne bereinigen: nur die gewählte Abo-App, je Rhythmus ein Plan.
  // Recharge meldet eine rein numerische App-ID (z. B. "294517"), Shopify Subscriptions eine gid.
  function isRechargeApp(appId) { appId = String(appId || ''); return /^\d+$/.test(appId) || /recharge/i.test(appId); }
  function cleanPlans(data) {
    var app = {};
    (data.groups || []).forEach(function (g) { app[String(g.id)] = g.appId; });
    var mode = RZ.subApp || 'auto';
    (data.variants || []).forEach(function (v) {
      var all = (v.plans || []).filter(function (p) { return planMonths(p.name) != null; });
      var rc = function (p) { return isRechargeApp(app[String(p.groupId)]); };
      var pick = all;
      if (mode === 'shopify' || mode === 'auto') {
        var own = all.filter(function (p) { return !rc(p); });
        pick = (own.length || mode === 'shopify') ? own : all;
      } else if (mode === 'recharge') {
        pick = all.filter(rc);
      }
      var seen = {};
      v.plans = pick.filter(function (p) { var m = planMonths(p.name); if (seen[m]) return false; seen[m] = 1; return true; });
    });
    return data;
  }
  function readData(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return cleanPlans(JSON.parse(el.textContent)); } catch (e) { console.warn('razeco: Produktdaten', e); return null; }
  }
  function gripOfData(data, fallback) {
    var t = ((data.title || '') + ' ' + (data.handle || '')).toLowerCase();
    return /body/.test(t) ? 'body' : (/face/.test(t) ? 'face' : fallback);
  }
  // Zwei getrennte Produkte (face + body) zu einem Modell mit Option "Variante" zusammenführen
  function mergeGrips(list) {
    if (list.length === 1) return list[0].data;
    var first = list[0].data;
    var out = { handle: first.handle, title: first.title, url: first.url, groups: [], variants: [],
      options: ['Variante'].concat(first.options || []), merged: true };
    list.forEach(function (it) {
      out.groups = out.groups.concat(it.data.groups || []);
      (it.data.variants || []).forEach(function (v) {
        out.variants.push(Object.assign({}, v, { options: [it.grip].concat(v.options), productHandle: it.data.handle, productUrl: it.data.url }));
      });
    });
    return out;
  }
  function readProduct(id, fallback) {
    var d = readData(id);
    if (d) return new Product(d);
    return fallback ? new Product(fallback()) : null;
  }
  function resolvePair(mainId, secondId, pageId, demo, handlesKey) {
    var a = readData(mainId), b = readData(secondId), list = [];
    if (a) list.push({ data: a, grip: gripOfData(a, 'face') });
    if (b) list.push({ data: b, grip: gripOfData(b, 'body') });
    if (!list.length) { var pg = readData(pageId); if (pg) list.push({ data: pg, grip: gripOfData(pg, 'face') }); }
    if (!list.length) return new Product(demo());
    RZ[handlesKey] = RZ[handlesKey] || [];
    list.forEach(function (it) { if (RZ[handlesKey].indexOf(it.data.handle) < 0) RZ[handlesKey].push(it.data.handle); });
    // Einzelnes Produkt ohne face/body-Option: Griff aus dem Titel als Option ergänzen
    if (list.length === 1) {
      var p1 = new Product(list[0].data);
      if (p1.gripIdx >= 0 && p1.values(p1.gripIdx).some(function (x) { return /face|body/i.test(x); })) return p1;
      return new Product(mergeGrips([list[0], { data: { variants: [], groups: [] }, grip: '' }]));
    }
    return new Product(mergeGrips(list));
  }
  RZ.refills = function () { return RZ._refills || (RZ._refills = resolvePair('rz-data-refills', 'rz-data-refills-body', 'rz-data-refills-page', demoRefills, 'refillsHandles')); };
  // Abo-Produkt für das Starterkit (nicht gelistet). Ohne eigenes Abo-Produkt: Refills selbst.
  RZ.abo = function () {
    if (RZ._abo) return RZ._abo;
    var d = readData('rz-data-abo');
    if (d) {
      var ap = new Product(d);
      // Ohne Abo-Pläne am Abo-Produkt: Pläne der Refills nutzen, damit der Kauf nicht scheitert
      if (ap.months().length) { RZ.aboHandle = RZ.aboHandle || d.handle; return (RZ._abo = ap); }
    }
    RZ.aboFallback = true;
    return (RZ._abo = RZ.refills());
  };
  RZ.kit = function () { return RZ._kit || (RZ._kit = resolvePair('rz-data-kit', 'rz-data-kit-body', 'rz-data-kit-page', demoKit, 'kitHandles')); };

  /* ------------------------------------------------------ Lieferzusage */
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; }
    return x;
  }
  // days: Laufzeit in Werktagen (aus der Sektion), sonst aus den Theme-Einstellungen
  function delivery(daysOverride) {
    var now = new Date();
    var cutoff = Number(RZ.cutoffHour == null ? 14 : RZ.cutoffHour);
    var days = Number(daysOverride) > 0 ? Number(daysOverride) : Number(RZ.deliveryDays == null ? 2 : RZ.deliveryDays);
    var weekday = now.getDay() !== 0 && now.getDay() !== 6;
    var ship = new Date(now.getTime());
    var today = weekday && now.getHours() < cutoff;
    if (!today) ship = addBusinessDays(now, 1);
    var arrive = addBusinessDays(ship, days);
    var cut = new Date(now.getTime()); cut.setHours(cutoff, 0, 0, 0);
    var mins = Math.max(0, Math.round((cut - now) / 60000));
    var long = arrive.toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long' });
    var short = arrive.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'long' }).replace('.,', ',');
    return {
      today: today,
      left: Math.floor(mins / 60) + ' Std ' + (mins % 60) + ' Min',
      long: long, short: short,
      shipDay: ship.toLocaleDateString('de-DE', { weekday: 'long' })
    };
  }
  RZ.delivery = delivery;
  function renderDelivery() {
    var d = delivery();
    $$('[data-rz-delivery]').forEach(function (el) {
      var own = Number(el.getAttribute('data-rz-delivery'));
      var d = own > 0 ? delivery(own) : delivery();
      el.textContent = d.today
        ? 'Bestell in den nächsten ' + d.left + ', dann geht deine Lieferung heute raus. Da: ' + d.long
        : 'Bestellst du jetzt, geht deine Lieferung ' + d.shipDay + ' raus. Da: ' + d.long;
    });
    $$('[data-rz-delivery-short]').forEach(function (el) { el.textContent = d.short; });
  }

  /* ------------------------------------------------------- Scroll-Lock */
  var locks = 0;
  function lock(on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    document.body.style.overflow = locks ? 'hidden' : '';
  }

  /* ================================================================ CART */
  var cart = RZ.cart = {
    state: null, removed: null, undoTimer: null, codeOpen: false, codeMsg: '', busy: false, upRhythm: {},
    root: null,

    init: function () {
      this.root = $('[data-rz-cart-drawer]');
      var self = this;
      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-rz-cart-open]');
        if (open && self.root) { e.preventDefault(); self.open(); return; }
        var close = e.target.closest('[data-rz-cart-close]');
        if (close) { e.preventDefault(); self.close(); return; }
        var act = e.target.closest('[data-rz-cart-act]');
        if (act) { e.preventDefault(); self.action(act); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen()) self.close();
      });
      document.addEventListener('change', function (e) {
        if (e.target.matches('[data-rz-code-input]')) self.code = e.target.value;
      });
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (f.matches('[data-rz-code-form]')) { e.preventDefault(); self.applyCode($('[data-rz-code-input]', f).value); return; }
        // Standard-Produktformulare (z. B. Default-Produkttemplate) per AJAX
        if (f.matches('form[action*="/cart/add"]') && !f.hasAttribute('data-rz-native')) {
          e.preventDefault();
          var fd = new FormData(f);
          var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
          if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
          var props = {};
          fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; });
          if (Object.keys(props).length) item.properties = props;
          self.add([item]);
        }
      });
      // Cart-Seite rendert dieselbe Ansicht
      this.page = $('[data-rz-cart-page]');
      if (this.page) this.refresh();
    },
    isOpen: function () { return this.root && !this.root.hidden; },
    open: function () {
      if (!this.root) { window.location.href = RZ.routes.cart; return; }
      if (this.root.hidden) { this.root.hidden = false; lock(true); }
      this.refresh();
      var btn = $('[data-rz-cart-close]', this.root);
      if (btn) btn.focus({ preventScroll: true });
    },
    close: function () {
      if (!this.root || this.root.hidden) return;
      this.root.hidden = true; lock(false);
      this.expireUndo(true);
    },
    fetch: function (url, body) {
      var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' };
      if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
      return window.fetch(url, opts).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      });
    },
    refresh: function () {
      var self = this;
      return this.fetch(RZ.routes.cart + '.js').then(function (c) { self.state = c; self.render(); return self.enforceKitRule(); });
    },
    // Klingen-Abo nur mit Starterkit: liegen Abo-Klingen ohne Griff im Warenkorb,
    // werden sie in dieselbe Packung als Einzelkauf umgewandelt.
    enforceKitRule: function () {
      var c = this.state, self = this;
      if (!RZ.aboOnlyKit || !c || this.enforcing) return Promise.resolve(c);
      var hasKit = c.items.some(isKit);
      var orphans = hasKit ? [] : c.items.filter(isAboLine);
      if (!orphans.length) return Promise.resolve(c);
      var R = RZ.refills(), up = {}, add = [];
      orphans.forEach(function (l) {
        up[l.key] = 0;
        var v = R.find({ grip: gripOf(l), pack: packOf(l) });
        if (v && v.id) add.push({ id: v.id, quantity: l.quantity });
      });
      this.enforcing = true;
      this.notice = 'Klingen im Abo gibt es nur zusammen mit dem Starterkit. Wir haben sie als Einzelkauf übernommen.';
      return this.fetch(RZ.routes.cartUpdate + '.js', { updates: up })
        .then(function () { return add.length ? self.fetch(RZ.routes.cartAdd + '.js', { items: add }) : null; })
        .then(function () { return self.fetch(RZ.routes.cart + '.js'); })
        .then(function (c2) { self.state = c2; self.render(); return c2; })
        .catch(function () { return c; })
        .then(function (r) { self.enforcing = false; return r; });
    },
    setBusy: function (on) {
      this.busy = on;
      if (this.root) this.root.querySelector('.rz-drawer').classList.toggle('is-loading', on);
    },
    // Hinweis oben im Warenkorb statt Browser-Pop-up
    flash: function (msg) {
      // open() lädt den Warenkorb neu und zeigt den Hinweis dabei an
      this.notice = msg;
      if (this.root && !this.root.hidden) this.refresh(); else this.open();
    },
    add: function (items) {
      var self = this;
      if (!items.length || items.some(function (i) { return !i.id; })) {
        // Produkt fehlt im Shop (Entwurf, nicht veröffentlicht oder nicht verknüpft): kein Browser-Pop-up, Hinweis im Warenkorb.
        self.flash(window.Shopify && window.Shopify.designMode
          ? 'Produkt nicht verfügbar: Es ist ein Entwurf, nicht im Onlineshop veröffentlicht oder nicht verknüpft (Theme-Einstellungen → Produkte).'
          : 'Dieses Produkt ist gerade nicht verfügbar. Bitte versuch es später noch einmal.');
        return Promise.resolve();
      }
      this.expireUndo(true);
      this.setBusy(true);
      return this.fetch(RZ.routes.cartAdd + '.js', { items: items })
        .then(function () { return self.refresh(); })
        .then(function () { if (RZ.autoOpenCart !== false) self.open(); })
        .catch(function (err) { self.flash((err && (err.description || err.message)) || 'Konnte nicht hinzugefügt werden.'); })
        .then(function () { self.setBusy(false); });
    },
    update: function (updates) {
      var self = this;
      this.setBusy(true);
      return this.fetch(RZ.routes.cartUpdate + '.js', { updates: updates })
        .then(function (c) { self.state = c; self.render(); return self.enforceKitRule(); })
        .catch(function (err) { self.flash((err && err.description) || 'Fehler beim Aktualisieren.'); self.refresh(); })
        .then(function () { self.setBusy(false); });
    },

    /* Positionen gruppieren: Kit + Klingen-Abo (gleiche _rz_bundle-ID) = eine Position */
    positions: function () {
      var c = this.state; if (!c) return [];
      var groups = {}, out = [];
      // cart/update.js liefert entfernte Zeilen teils mit Menge 0 zurück
      c.items.filter(function (it) { return it.quantity > 0; }).forEach(function (it) {
        var b = it.properties && it.properties._rz_bundle;
        if (b) {
          if (!groups[b]) { groups[b] = { bundle: b, lines: [] }; out.push(groups[b]); }
          groups[b].lines.push(it);
        } else out.push({ bundle: null, lines: [it] });
      });
      return out.map(function (p) { return describe(p); });
    },

    render: function () {
      var c = this.state; if (!c) return;
      var pos = this.positions();
      var count = pos.reduce(function (a, p) { return a + p.qty; }, 0);
      $$('[data-rz-cart-count]').forEach(function (el) { el.textContent = count; });
      var targets = [];
      if (this.root) targets.push(this.root);
      if (this.page) targets.push(this.page);
      var self = this;
      targets.forEach(function (root) {
        var label = $('[data-rz-cart-label]', root);
        if (label) label.textContent = count === 1 ? '1 Position' : count + ' Positionen';
        var body = $('[data-rz-cart-body]', root);
        if (body) body.innerHTML = self.bodyHtml(pos);
        var foot = $('[data-rz-cart-footer]', root);
        if (foot) {
          foot.hidden = pos.length === 0;
          var t = $('[data-rz-cart-total]', foot); if (t) t.textContent = eur(c.total_price);
        }
      });
      renderDelivery();
    },

    bodyHtml: function (pos) {
      var c = this.state, h = '';
      if (this.notice) {
        h += '<p style="font-size:15px;color:var(--rz-muted-2);background:var(--rz-card);border-radius:14px;padding:12px 14px">' + esc(this.notice) + '</p>';
        this.notice = '';
      }
      if (!pos.length) {
        h += '<div style="padding:30px 0 10px">'
          + '<div style="font-size:26px;font-weight:400;letter-spacing:-0.02em">Noch nichts drin.</div>'
          + '<p style="font-size:16px;color:var(--rz-muted);margin-top:10px;max-width:32ch">Hast du schon einen passenden Griff, reichen Klingen.</p>'
          + '<div style="display:flex;flex-direction:column;gap:10px;margin-top:26px;align-items:flex-start">'
          + '<a href="' + esc(RZ.urls.refills) + '" class="rz-btn-dark" style="height:52px;padding:0 28px;font-size:16px">refills ansehen</a>'
          + '<a href="' + esc(RZ.urls.kit) + '" class="rz-btn-outline" style="height:52px;padding:0 28px;font-size:16px">starterkit</a>'
          + '</div></div>';
      }
      if (this.removed) {
        h += '<div style="display:flex;gap:16px;align-items:center;font-size:15px;color:var(--rz-muted)">'
          + '<div style="flex:1;min-width:0">Entfernt.</div>'
          + '<button type="button" data-rz-cart-act="undo" class="rz-link" style="flex:none;font-size:15px">rückgängig</button></div>';
      }
      pos.forEach(function (p, i) { h += lineHtml(p, i); });

      var cross = crossSell(pos);
      if (cross) {
        h += '<div style="display:flex;gap:18px;align-items:center">'
          + '<div style="flex:none;width:56px;height:56px;border-radius:14px;background:var(--rz-card);overflow:hidden"><img src="' + esc(cross.image) + '" alt="" style="width:100%;height:100%;object-fit:cover;object-position:50% 74%"></div>'
          + '<div style="flex:1;min-width:0"><div style="font-size:16px;font-weight:500">' + esc(cross.title) + '</div>'
          + '<div style="font-size:15px;color:var(--rz-muted);margin-top:2px">' + esc(cross.priceText) + ' · ' + esc(cross.note) + '</div></div>'
          + '<button type="button" data-rz-cart-act="cross" class="rz-btn-outline" style="flex:none;height:44px;padding:0 20px;font-size:15px">hinzufügen</button></div>';
      }

      if (pos.length) {
        var recur = recurring(pos);
        var discCodes = (c.cart_level_discount_applications || []).map(function (d) { return d.title; });
        var lineDisc = 0;
        c.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { lineDisc += a.amount; }); });
        var disc = c.total_discount || 0;
        h += '<div style="border-top:1px solid rgb(var(--rz-text-rgb) / 0.1);padding-top:18px;display:flex;flex-direction:column;gap:9px">'
          + row('Zwischensumme', eur(c.items_subtotal_price + lineDisc));
        if (disc > 0) {
          var dl = discCodes.length ? 'Rabatt ' + discCodes.join(', ') : 'Rabatt';
          h += '<div style="display:flex;justify-content:space-between;gap:16px;font-size:16px"><span style="color:var(--rz-muted)">' + esc(dl) + '</span><span style="color:var(--rz-accent)">−' + eur(disc) + '</span></div>';
        }
        h += row('Versand', RZ.shippingLabel || 'kostenlos')
          + '<div style="border-top:1px solid rgb(var(--rz-text-rgb) / 0.15);margin-top:7px;padding-top:14px;display:flex;justify-content:space-between;gap:16px;font-size:20px;font-weight:500;letter-spacing:-0.01em"><span>'
          + (recur.length ? 'Erste Lieferung' : 'Gesamt') + '</span><span>' + eur(c.total_price) + '</span></div>';
        recur.forEach(function (t) { h += '<p style="font-size:15px;color:var(--rz-muted)">' + esc(t) + '</p>'; });
        if (recur.length) h += '<p style="font-size:15px;color:var(--rz-muted)">Jederzeit pausieren oder abbrechen.</p>';
        h += '</div>';

        if (!this.codeOpen) {
          h += '<button type="button" data-rz-cart-act="code" class="rz-muted-btn" style="font-size:15px;align-self:flex-start">Rabattcode</button>';
        } else {
          h += '<form data-rz-code-form><div style="display:flex;gap:8px">'
            + '<input data-rz-code-input value="' + esc(this.code || '') + '" placeholder="Rabattcode" aria-label="Rabattcode" class="rz-input-focus" style="flex:1;min-width:0;height:46px;padding:0 18px;border-radius:999px;border:1px solid rgb(var(--rz-text-rgb) / 0.18);background:var(--rz-card);font-size:16px;color:var(--rz-text);outline:none">'
            + '<button type="submit" class="rz-btn-outline" style="flex:none;height:46px;padding:0 22px;font-size:15px">einlösen</button></div>'
            + (this.codeMsg ? '<p style="font-size:15px;color:var(--rz-muted-2);margin-top:10px">' + esc(this.codeMsg) + '</p>' : '')
            + '</form>';
        }
      }
      return h;
    },

    action: function (el) {
      var a = el.getAttribute('data-rz-cart-act');
      var i = Number(el.getAttribute('data-i'));
      var pos = this.positions();
      var p = pos[i];
      var self = this;
      if (a === 'code') { this.codeOpen = true; this.render(); var inp = $('[data-rz-code-input]', this.root || this.page); if (inp) inp.focus(); return; }
      if (a === 'undo') { this.restore(); return; }
      if (a === 'cross') {
        var x = crossSell(pos); if (!x) return;
        this.add([x.item]); return;
      }
      if (!p) return;
      if (a === 'inc' || a === 'dec') {
        var d = a === 'inc' ? 1 : -1;
        if (p.qty + d <= 0) { this.drop(p); return; }
        this.expireUndo(true);
        var up = {};
        p.lines.forEach(function (l) { up[l.key] = Math.max(0, l.quantity + d * (l.quantity / p.qty)); });
        this.update(up);
      } else if (a === 'remove') {
        this.drop(p);
      } else if (a === 'uprhythm') {
        this.upRhythm[p.refLine.key] = Number(el.getAttribute('data-m'));
        this.render();
      } else if (a === 'upsell') {
        var u = p.upsell; if (!u || !u.apply.id) return;
        this.expireUndo(true);
        var rl = p.refLine;
        // _rz_up markiert die Position: ein angenommener Vorschlag pro Position, danach kein weiterer
        var add = { id: u.apply.id, quantity: u.apply.qty, properties: Object.assign({}, rl.properties || {}, { _rz_up: '1' }) };
        if (u.apply.plan && u.apply.plan.id) add.selling_plan = u.apply.plan.id;
        var rm = {}; rm[rl.key] = 0;
        this.setBusy(true);
        this.fetch(RZ.routes.cartUpdate + '.js', { updates: rm })
          .then(function () { return self.fetch(RZ.routes.cartAdd + '.js', { items: [add] }); })
          .then(function () { return self.refresh(); })
          .catch(function (err) { self.flash((err && err.description) || 'Fehler beim Aktualisieren.'); self.refresh(); })
          .then(function () { self.setBusy(false); });
      }
    },
    drop: function (p) {
      var up = {};
      p.lines.forEach(function (l) { up[l.key] = 0; });
      this.removed = p.lines.map(function (l) {
        var it = { id: l.variant_id, quantity: l.quantity };
        if (l.properties && Object.keys(l.properties).length) it.properties = l.properties;
        if (l.selling_plan_allocation) it.selling_plan = l.selling_plan_allocation.selling_plan.id;
        return it;
      });
      var self = this, token = this.removed;
      clearTimeout(this.undoTimer);
      this.undoTimer = setTimeout(function () { if (self.removed === token) { self.removed = null; self.render(); } }, 8000);
      this.update(up);
    },
    restore: function () {
      var items = this.removed; if (!items) return;
      clearTimeout(this.undoTimer);
      this.removed = null;
      var self = this;
      this.setBusy(true);
      this.fetch(RZ.routes.cartAdd + '.js', { items: items })
        .then(function () { return self.refresh(); })
        .catch(function () { self.refresh(); })
        .then(function () { self.setBusy(false); });
    },
    expireUndo: function (silent) {
      clearTimeout(this.undoTimer);
      if (this.removed) { this.removed = null; if (!silent) this.render(); }
    },
    applyCode: function (code) {
      code = (code || '').trim();
      this.code = code;
      var self = this;
      if (!code) { this.codeMsg = 'Kein Code eingegeben.'; this.render(); return; }
      var existing = (this.state.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      if (existing.indexOf(code) < 0) existing.push(code);
      this.setBusy(true);
      this.fetch(RZ.routes.cartUpdate + '.js', { discount: existing.join(',') })
        .then(function (c) {
          self.state = c;
          var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
          self.codeMsg = hit && hit.applicable
            ? hit.code.toUpperCase() + ' angewendet.'
            : 'Diesen Code kennen wir nicht.';
          self.render();
        })
        .catch(function () { self.codeMsg = 'Code konnte nicht geprüft werden.'; self.render(); })
        .then(function () { self.setBusy(false); });
    }
  };

  function row(l, r) {
    return '<div style="display:flex;justify-content:space-between;gap:16px;font-size:16px"><span style="color:var(--rz-muted)">' + esc(l) + '</span><span>' + esc(r) + '</span></div>';
  }

  function gripOf(line) {
    var vals = (line.options_with_values || []).map(function (o) { return o.value; });
    for (var i = 0; i < vals.length; i++) { if (/face/i.test(vals[i])) return 'face'; if (/body/i.test(vals[i])) return 'body'; }
    var t = (line.variant_title || '') + ' ' + line.product_title;
    return /body/i.test(t) ? 'body' : (/face/i.test(t) ? 'face' : null);
  }
  function packOf(line) {
    var vals = (line.options_with_values || []).map(function (o) { return o.value; });
    for (var i = 0; i < vals.length; i++) { var m = vals[i].match(/(\d+)/); if (m) return parseInt(m[1], 10); }
    return null;
  }
  function monthsOf(line) {
    return line.selling_plan_allocation ? planMonths(line.selling_plan_allocation.selling_plan.name) : null;
  }
  function rhythmOf(line) {
    var m = monthsOf(line);
    if (m) return rhythmLabel(m);
    return line.selling_plan_allocation ? line.selling_plan_allocation.selling_plan.name : '';
  }
  function inList(list, h) { return !!(list && h && list.indexOf(h) >= 0); }
  function isKit(line) { RZ.kit(); return inList(RZ.kitHandles, line.handle); }
  // Kit-Preis mit Klingen-Abo: eigene Abo-Variante, sonst Einmalpreis minus Kit-Rabatt (Theme-Einstellung, Rabatt kommt an der Kasse)
  function kitAboPrice(K, v) {
    if (K.modeIdx >= 0 || !v) return v ? v.price : 0;
    return Math.max(0, v.price - (Number(RZ.kitAboDiscount) || 0));
  }
  function isAboLine(line) {
    RZ.abo();
    if (RZ.aboHandle && line.handle === RZ.aboHandle) return true;
    // Abo-Produkt ohne Pläne: Abo-Klingen laufen über die Refills
    return !!(RZ.aboFallback && line.selling_plan_allocation && inList(RZ.refillsHandles, line.handle));
  }
  function isRef(line) { RZ.refills(); return inList(RZ.refillsHandles, line.handle) || isAboLine(line); }

  // Beschreibung einer sichtbaren Position
  function describe(p) {
    var kit = p.lines.filter(isKit)[0];
    var ref = p.lines.filter(isRef)[0];
    var main = kit || p.lines[0];
    var qty = main.quantity;
    var price = p.lines.reduce(function (a, l) { return a + l.final_line_price; }, 0);
    var grip = gripOf(main);
    var d = { lines: p.lines, qty: qty, price: price, refLine: null, upsell: null };
    if (kit) {
      var aboKit = !!ref || /abo/i.test(kit.variant_title || '');
      d.kind = 'kit'; d.grip = grip;
      d.title = (kit.product_title || 'razeco5 starterkit') + (grip && kit.product_title.toLowerCase().indexOf(grip) < 0 ? ' ' + grip : '');
      d.meta = aboKit
        ? 'mit Klingen-Abo' + (ref ? ' · ' + packOf(ref) + 'er ' + rhythmOf(ref) : '')
        : 'einmaliger Kauf';
      d.image = kit.image || (grip === 'body' ? RZ.fallbackImages.kitBody : RZ.fallbackImages.kitFace);
      d.contain = true;
      if (ref) d.refLine = ref;
    } else if (ref || isRef(main)) {
      ref = ref || main;
      d.kind = 'ref'; d.grip = grip;
      d.title = (grip ? grip + ' ' : '') + 'refills';
      d.meta = packOf(ref) + 'er · ' + (ref.selling_plan_allocation ? rhythmOf(ref) : 'einmalig');
      d.image = ref.image || (grip === 'body' ? RZ.fallbackImages.refBody : RZ.fallbackImages.refFace);
      d.refLine = ref;
    } else {
      d.kind = 'other';
      d.title = main.product_title;
      var meta = [];
      if (main.variant_title && !main.product_has_only_default_variant) meta.push(main.variant_title);
      meta.push(main.selling_plan_allocation ? main.selling_plan_allocation.selling_plan.name : 'einmalig');
      d.meta = meta.join(' · ');
      d.image = main.image;
      d.contain = true;
    }
    if (d.refLine && RZ.showUpsell !== false) d.upsell = upsellFor(d.refLine, d.grip);
    return d;
  }

  /* ----------------------------------------------------------- Upsell
     Ein Vorschlag pro Position, in dieser Reihenfolge:
     1. Einmalkauf → Abo (gleiche Packung, günstiger je Lieferung)
     2. Abo → größere Packung + passender Rhythmus: nie weniger Klingen als jetzt,
        höchstens doppelt so viele im Jahr, günstiger pro Klinge
     3. Einmalkauf ohne Abo → nächstgrößere Packung (mehr Klingen, günstiger pro Klinge) */
  function upsellFor(line, grip) {
    var R = isAboLine(line) ? RZ.abo() : RZ.refills();
    if (R.data.demo || (line.properties && line.properties._rz_up)) return null;
    var n = packOf(line), q = line.quantity;
    var cur = R.find({ grip: grip, pack: n });
    if (!n || !cur) return null;
    var packs = R.packs();
    if (!line.selling_plan_allocation) {
      // 1. Abo-Umstellung (nicht, wenn es das Klingen-Abo nur mit Starterkit gibt)
      var months = R.months();
      if (!RZ.aboOnlyKit && cur.plans && cur.plans.length) {
        var pref = cart.upRhythm[line.key] || Number(RZ.defaultRhythm || 3);
        var plan = R.planFor(cur, pref);
        if (plan && plan.price < cur.price) {
          var m = planMonths(plan.name);
          var avail = months.filter(function (x) { return cur.plans.some(function (p) { return planMonths(p.name) === x; }); });
          return {
            kind: 'abo', key: line.key, rhythms: avail, months: m,
            text: 'Im Abo ' + eur(plan.price) + ' statt ' + eur(cur.price) + ' — du sparst ' + eur((cur.price - plan.price) * q) + ' pro Lieferung. Jederzeit kündbar.',
            label: 'Als Abo', apply: { id: cur.id, plan: plan, qty: q }
          };
        }
      }
      // 3. Größere Packung, einmalig
      var next = packs.filter(function (p) { return p.n > n; })[0];
      if (!next) return null;
      var nv = R.find({ grip: grip, pack: next.n });
      if (!nv || !nv.id || nv.available === false) return null;
      var perNow = cur.price / n, perNext = nv.price / next.n;
      if (perNext >= perNow) return null;
      return {
        kind: 'pack', key: line.key,
        text: next.n + 'er: ' + ((next.n - n) * q) + ' Klingen mehr für ' + eur((nv.price - cur.price) * q) + ' mehr — ' + eur(Math.round(perNext)) + ' statt ' + eur(Math.round(perNow)) + ' pro Klinge.',
        label: next.n + 'er nehmen', apply: { id: nv.id, plan: null, qty: q }
      };
    }
    // 2. Abo: größere Packung mit passendem Rhythmus
    var r = monthsOf(line);
    if (!r) return null;
    var curPrice = line.selling_plan_allocation.price || cur.price;
    var bladesYear = 12 * n * q / r, costYear = 12 / r * curPrice * q, perCur = curPrice / n;
    var best = null;
    packs.forEach(function (p) {
      if (p.n <= n) return;
      var v = R.find({ grip: grip, pack: p.n });
      if (!v || !v.id || v.available === false) return;
      (v.plans || []).forEach(function (pl) {
        var r2 = planMonths(pl.name);
        if (!r2) return;
        var b2 = 12 * p.n * q / r2;
        if (b2 < bladesYear - 0.01 || b2 > bladesYear * 2 + 0.01) return;
        if (pl.price / p.n >= perCur) return;
        var c2 = 12 / r2 * pl.price * q;
        // Nur Vorschläge, die im Jahr nicht mehr kosten (sonst wäre der Upsell nur „mehr Klingen für mehr Geld“)
        if (c2 > costYear + 0.5) return;
        if (!best || b2 < best.b2 - 0.01 || (Math.abs(b2 - best.b2) < 0.01 && c2 < best.c2)) {
          best = { n: p.n, v: v, plan: pl, r2: r2, b2: b2, c2: c2 };
        }
      });
    });
    if (!best) return null;
    var head = best.n + 'er ' + rhythmLabel(best.r2) + ': ';
    var text;
    if (Math.abs(best.b2 - bladesYear) < 0.01) {
      text = head + 'gleich viele Klingen, ' + (best.r2 > r ? 'seltener Versand, ' : '') + 'du sparst ' + eur(Math.round(costYear - best.c2)) + ' im Jahr.';
    } else {
      text = head + eur(Math.round(best.plan.price / best.n)) + ' statt ' + eur(Math.round(perCur)) + ' pro Klinge. '
        + Math.round(best.b2 - bladesYear) + ' Klingen mehr im Jahr' + (costYear - best.c2 >= 1 ? ', ' + eur(Math.round(costYear - best.c2)) + ' günstiger' : ' zum gleichen Preis')
        + (best.r2 > r ? ', seltener Versand.' : '.');
    }
    return { kind: 'pack', key: line.key, text: text, label: best.n + 'er nehmen', apply: { id: best.v.id, plan: best.plan, qty: q } };
  }

  function lineHtml(p, i) {
    var img = p.image
      ? (p.contain
        ? '<img src="' + esc(p.image) + '" alt="" style="max-height:66px;max-width:66px;object-fit:contain;mix-blend-mode:multiply">'
        : '<img src="' + esc(p.image) + '" alt="" style="width:100%;height:100%;object-fit:cover;object-position:50% 74%">')
      : '';
    var h = '<div data-cart-line style="display:flex;gap:18px;align-items:flex-start;padding-bottom:16px;border-bottom:1px solid rgb(var(--rz-text-rgb) / 0.1)">'
      + '<div style="flex:none;width:76px;height:76px;border-radius:16px;background:var(--rz-card);overflow:hidden;display:flex;align-items:center;justify-content:center">' + img + '</div>'
      + '<div style="flex:1;min-width:0">'
      + '<div style="display:flex;gap:14px;align-items:baseline"><div style="font-size:17px;font-weight:500;flex:1;min-width:0">' + esc(p.title) + '</div>'
      + '<div style="font-size:17px;font-weight:500;flex:none">' + eur(p.price) + '</div></div>'
      + '<div style="font-size:15px;color:var(--rz-muted);margin-top:4px">' + esc(p.meta) + '</div>'
      + '<div style="display:flex;align-items:center;gap:14px;margin-top:14px">'
      + '<div style="display:flex;align-items:center;gap:2px;border:1px solid rgb(var(--rz-text-rgb) / 0.18);border-radius:999px;height:38px;padding:0 4px">'
      + '<button type="button" class="rz-qty-btn" data-rz-cart-act="dec" data-i="' + i + '" aria-label="Menge verringern">−</button>'
      + '<div style="min-width:22px;text-align:center;font-size:15px;font-weight:500">' + p.qty + '</div>'
      + '<button type="button" class="rz-qty-btn" data-rz-cart-act="inc" data-i="' + i + '" aria-label="Menge erhöhen">+</button></div>'
      + '<div style="flex:1"></div>'
      + '<button type="button" class="rz-muted-btn" data-rz-cart-act="remove" data-i="' + i + '" style="font-size:15px">entfernen</button></div>';
    if (p.upsell) {
      var u = p.upsell;
      h += '<div style="margin-top:14px;background:var(--rz-card);border-radius:16px;padding:14px 16px">'
        + '<div style="display:flex;gap:14px;align-items:center;flex-wrap:wrap">'
        + '<div style="flex:1;min-width:150px;font-size:15px">' + esc(u.text) + '</div>'
        + '<button type="button" class="rz-btn-dark" data-rz-cart-act="upsell" data-i="' + i + '" style="flex:none;height:40px;padding:0 18px;font-size:15px">' + esc(u.label) + '</button></div>';
      if (u.kind === 'abo' && u.rhythms.length > 1) {
        h += '<div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:10px" role="group" aria-label="Rhythmus">'
          + u.rhythms.map(function (m) {
            return '<button type="button" class="rz-chip-sm' + (m === u.months ? ' is-active' : '') + '" data-rz-cart-act="uprhythm" data-i="' + i + '" data-m="' + m + '" style="height:32px;padding:0 12px;font-size:13px">' + rhythmLabel(m) + '</button>';
          }).join('') + '</div>';
      }
      h += '</div>';
    }
    return h + '</div></div>';
  }

  // Cross-Sell: 1. Griff ohne passende Klingen → passende Klingen im Abo (face-Kit → face, body-Kit → body)
  //             2. nur Klingen ohne Starterkit im Warenkorb → die andere Variante (face ↔ body)
  function crossSell(pos) {
    if (RZ.showCrossSell === false || !pos.length) return null;
    var R = RZ.refills(); if (R.data.demo) return null;
    var refGrips = pos.filter(function (p) { return p.kind === 'ref' || p.refLine; }).map(function (p) { return p.grip; });
    var kitGrip = pos.filter(function (p) { return p.kind === 'kit' && !p.refLine && p.grip && refGrips.indexOf(p.grip) < 0; }).map(function (p) { return p.grip; })[0];
    var g, note, packs = R.packs(), pack;
    if (kitGrip) {
      g = kitGrip; note = 'Ersatzklingen für deinen Griff'; pack = packs[0];
    } else {
      // Nur Klingen im Warenkorb (oder Kit mit Klingen): keine Klingen der anderen Variante (face/body) vorschlagen
      return null;
    }
    if (!g || !pack) return null;
    // Abo nur mit Starterkit: Griff im Warenkorb → Abo-Produkt, sonst einmalig
    var withKit = !!kitGrip;
    var M = (RZ.aboOnlyKit && withKit) ? RZ.abo() : R;
    var aboOffer = !RZ.aboOnlyKit || withKit;
    var o = M.offer(g, pack.n, aboOffer, RZ.defaultRhythm || 3);
    if (!o || !o.variant.id || o.variant.available === false) return null;
    var item = { id: o.variant.id, quantity: 1 };
    if (o.plan && o.plan.id) item.selling_plan = o.plan.id;
    return {
      title: g + ' refills ' + pack.n + 'er',
      priceText: eur(o.price) + (o.plan ? ' im Abo, ' + rhythmLabel(planMonths(o.plan.name)) : ' einmalig'),
      note: note,
      image: o.variant.image || (g === 'body' ? RZ.fallbackImages.refBody : RZ.fallbackImages.refFace),
      item: item
    };
  }

  function recurring(pos) {
    var subs = [];
    pos.forEach(function (p) {
      p.lines.forEach(function (l) {
        if (!l.selling_plan_allocation) return;
        var per = (l.selling_plan_allocation.price || l.final_price) * l.quantity;
        var name = isKit(l) ? '' : (p.kind === 'kit'
          ? (p.grip ? p.grip + ' ' : '') + 'Klingen ' + packOf(l) + 'er'
          : (p.kind === 'ref' ? (p.grip ? p.grip + ' ' : '') + 'refills ' + packOf(l) + 'er' : l.product_title));
        subs.push({ name: name, per: per, rhythm: rhythmOf(l) });
      });
    });
    if (subs.length > 1 && subs.every(function (s) { return s.rhythm === subs[0].rhythm; })) {
      var sum = subs.reduce(function (a, s) { return a + s.per; }, 0);
      return ['Ab der zweiten Lieferung: ' + eur(sum) + ' ' + subs[0].rhythm + '.'];
    }
    return subs.map(function (s) { return 'Ab der zweiten Lieferung: ' + s.name + ' — ' + eur(s.per) + ' ' + s.rhythm + '.'; });
  }

  /* ========================================================= Sticky-Leiste */
  function Sticky(root) {
    var bar = $('[data-rz-sticky]', root);
    var sentinel = $('[data-rz-sticky-sentinel]', root);
    if (!bar || !sentinel) return;
    var ticking = false;
    function check() {
      ticking = false;
      bar.hidden = !(sentinel.getBoundingClientRect().top < 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }
  function setText(root, key, val) {
    $$('[data-rz-t="' + key + '"]', root).forEach(function (el) { el.textContent = val; });
  }
  function setShow(root, key, on) {
    $$('[data-rz-if="' + key + '"]', root).forEach(function (el) { el.hidden = !on; });
  }
  function perBlade(price, n) { return eur(Math.round(price / n)); }

  /* ====================================================== Starterkit-Wizard */
  function KitWizard(root) {
    var kitPage = readData('rz-data-kit-page');
    var K = (!kitPage || inList(RZ.kitHandles, (RZ.kit(), kitPage.handle))) ? RZ.kit() : readProduct('rz-data-kit-page'), R = RZ.abo();
    var RO = RZ.refills(); // Einmalkauf: Klingen ohne Abo aus den Refills
    var params = new URLSearchParams(window.location.search);
    var grips = K.grips().length ? K.grips() : ['face', 'body'];
    var packs = R.packs();
    var months = R.months().length ? R.months() : DEMO_MONTHS;
    var cfg = root.dataset;
    var s = {
      // Keine Griffauswahl mehr: es gilt die Variante der Seite (face- bzw. body-Kit), ?grip= in der URL zählt nicht
      grip: (cfg.defaultGrip || params.get('grip') || 'face').toLowerCase(),
      mode: cfg.subFirst === 'false' ? 'once' : 'abo',
      pack: Number(params.get('pack') || cfg.defaultPack || 10),
      rhythm: Number(params.get('rhythm') || RZ.defaultRhythm || 3),
      step: 0
    };
    if (params.get('variant')) {
      var pv = K.variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0];
      if (pv && K.gripIdx >= 0) s.grip = pv.options[K.gripIdx].toLowerCase();
    }
    if (months.indexOf(s.rhythm) < 0) s.rhythm = months[Math.min(1, months.length - 1)];
    if (packs.length && !packs.some(function (p) { return p.n === s.pack; })) s.pack = packs[Math.min(1, packs.length - 1)].n;
    var popular = Number(cfg.popularPack || 10);
    var self = this;

    // Rhythmus-Pills aus Selling Plans
    var pills = $('[data-rz-rhythms]', root);
    if (pills && R.months().length) {
      pills.innerHTML = months.map(function (m) {
        return '<button type="button" class="rz-chip-sm" data-rz-rhythm="' + m + '">' + rhythmLabel(m) + '</button>';
      }).join('');
    }
    // Packungskarten
    var grid = $('[data-rz-packgrid]', root);
    function bladeOffer(n, abo) { return abo ? R.offer(s.grip, n, true, s.rhythm) : (RO.offer(s.grip, n, false) || R.offer(s.grip, n, false)); }
    function renderPacks(abo) {
      if (!grid || !packs.length) return;
      var base = bladeOffer(packs[0].n, abo);
      grid.innerHTML = packs.map(function (p) {
        var o = bladeOffer(p.n, abo);
        if (!o) return '';
        var per = o.price / p.n;
        var pct = base ? Math.round((1 - per / (base.price / packs[0].n)) * 100) : 0;
        var cls = 'rz-pack' + (p.n === popular ? ' is-popular' : '') + (p.n === s.pack ? ' is-active' : '');
        return '<button type="button" class="' + cls + '" data-rz-pack="' + p.n + '">'
          + (p.n === popular ? '<span style="position:absolute;top:-11px;left:16px;background:var(--rz-btn);color:var(--rz-btn-text);font-size:11px;font-weight:500;padding:4px 10px;border-radius:999px">Empfohlen</span>' : '')
          + '<span style="font-size:15px;font-weight:500">' + p.n + 'er</span>'
          + '<span style="display:flex;align-items:baseline;gap:8px;margin-top:10px;flex-wrap:wrap"><span style="font-size:18px;font-weight:500;white-space:nowrap">' + eur(o.price) + '</span>'
          + (o.reg > o.price ? '<span style="font-size:13px;color:var(--rz-muted);text-decoration:line-through;white-space:nowrap">' + eur(o.reg) + '</span>' : '') + '</span>'
          + '<span style="display:block;margin-top:4px;font-size:12px;color:var(--rz-muted);white-space:nowrap">' + perBlade(o.price, p.n) + ' pro Klinge'
          + (pct > 0 ? ' <span style="font-weight:500;color:var(--rz-positive)">−' + pct + ' %</span>' : '') + '</span></button>';
      }).join('');
    }

    function kitPrice(abo) {
      var v = K.find({ grip: s.grip, abo: K.modeIdx >= 0 ? abo : null }) || K.variants[0];
      return { variant: v, price: v ? (abo ? kitAboPrice(K, v) : v.price) : 0 };
    }
    function update() {
      var abo = s.mode === 'abo';
      var once = kitPrice(false), kAbo = kitPrice(true);
      var blades = R.offer(s.grip, s.pack, true, s.rhythm);
      var first = kAbo.price + (blades ? blades.price : 0);
      // Einmalkauf: Starterkit plus Klingen einmalig (ohne Abo)
      var onceBlades = bladeOffer(s.pack, false);
      var total = abo ? first : once.price + (onceBlades ? onceBlades.price : 0);

      root.classList.toggle('is-abo', abo);
      setText(root, 'kit-abo-price', eur(kAbo.price));
      setText(root, 'kit-once-price', eur(once.price));
      setText(root, 'kit-save', 'Du sparst ' + eur(Math.max(0, once.price - kAbo.price)));
      setShow(root, 'kit-save', once.price > kAbo.price);
      setText(root, 'kit-once-label', abo ? 'oder einmalig kaufen (' + eur(once.price) + ')' : 'zurück zum Abo');
      setText(root, 's1-summary', abo ? 'Mit Klingen-Abo' : 'Einmaliger Kauf (' + eur(once.price) + ')');
      setText(root, 's2-summary', rhythmLabel(s.rhythm));
      setText(root, 's3-summary', abo ? s.pack + 'er' : s.pack + 'er einmalig');
      setText(root, 'kit-first', eur(first));
      setText(root, 'kit-first-kit', eur(kAbo.price));
      setText(root, 'kit-first-blades-label', s.grip + ' Refill ' + s.pack + 'er im Abo');
      setText(root, 'kit-first-blades', blades ? eur(blades.price) : '');
      setText(root, 'kit-recurring', 'Ab der zweiten Lieferung kommt nur noch das Refill (' + s.pack + 'er) — ' + (blades ? eur(blades.price) : '') + ' ' + rhythmLabel(s.rhythm) + '. Der Griff bleibt.');
      setText(document, 'kit-cta', 'In den Warenkorb');
      setText(document, 'kit-total', eur(total));
      setText(document, 'kit-grip', s.grip);

      var sub = $('[data-rz-subcard]', root); if (sub) sub.classList.toggle('is-dim', !abo);
      var ol = $('[data-rz-oncelink]', root); if (ol) ol.classList.toggle('is-active', !abo);

      // Schritte
      var last = abo ? 2 : 1;
      $$('[data-rz-step]', root).forEach(function (el) {
        var i = Number(el.getAttribute('data-rz-step'));
        el.classList.toggle('is-done', s.step > i);
        el.hidden = i > last || (i > 0 && s.step < i);
        var num = $('.rz-step-num', el);
        if (num) num.textContent = s.step > i ? '✓' : ('0' + (i + 1));
      });
      $$('[data-rz-act="next2"]', root).forEach(function (b) { b.hidden = !abo; });
      $$('[data-rz-dot]', root).forEach(function (el) {
        var i = Number(el.getAttribute('data-rz-dot'));
        el.hidden = i > last;
        el.style.background = (i === 0 || s.step >= i) ? 'var(--rz-text)' : 'rgb(var(--rz-text-rgb) / 0.15)';
      });
      $$('[data-rz-rhythm]', root).forEach(function (el) { el.classList.toggle('is-active', Number(el.getAttribute('data-rz-rhythm')) === s.rhythm); });
      $$('[data-rz-grip]', root).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-rz-grip').toLowerCase() === s.grip); });
      $$('[data-rz-grip-show]').forEach(function (el) { el.hidden = el.getAttribute('data-rz-grip-show') !== s.grip; });
      renderPacks(abo);

      // Sticky
      setText(document, 'sticky-name', root.getAttribute('data-title') || 'razeco5 starterkit');
      setText(document, 'sticky-meta', s.grip + ' · ' + (abo ? 'mit Klingen-Abo' : 'einmaliger Kauf'));
      // Vor der Packungswahl: günstigster Klingenpreis („ab …“), danach der Preis der gewählten Packung
      var minPer = 0;
      packs.forEach(function (p) { var po = R.offer(s.grip, p.n, true, s.rhythm); if (po && (!minPer || po.price / p.n < minPer)) minPer = po.price / p.n; });
      var perTxt = s.step >= 2 || !minPer ? (blades ? perBlade(blades.price, s.pack) : '') : 'ab ' + eur(Math.round(minPer));
      setText(document, 'sticky-per', abo && blades ? perTxt + ' pro Klinge' : (onceBlades && s.step >= 1 ? 'Kit + ' + s.pack + ' Klingen' : 'einmalig'));
      setText(document, 'sticky-total-label', abo ? 'Erste Lieferung' : 'Einmalig');
      setText(document, 'sticky-total', eur(total));
      // „In den Warenkorb“ erst am Ende des Wizards (Abo: ab 03 Rhythmus; einmalig: ab 02 Klingen)
      var done = s.step >= last;
      root._wizardDone = done;
      $$('[data-rz-act="add"]', root).forEach(function (b) { b.hidden = !done; });
      setText(document, 'sticky-cta', done ? 'In den Warenkorb' : 'Weiter zur Auswahl');
      var sImg = $('[data-rz-sticky-img]');
      if (sImg) sImg.src = s.grip === 'body' ? sImg.getAttribute('data-body') : sImg.getAttribute('data-face');
      // URL mit Variante synchronisieren
      var v = (abo ? kAbo : once).variant;
      if (v && v.id && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }
    function go(i) { s.step = Math.min(i, s.mode === 'abo' ? 2 : 1); update(); }
    this.add = function () {
      var abo = s.mode === 'abo';
      var kv = kitPrice(abo).variant;
      if (!kv || !kv.id) { cart.add([{ id: null }]); return; }
      if (!abo) {
        // Einmalig: Starterkit und Klingen als normale Einzelkäufe, ohne Abo
        var onceItems = [{ id: kv.id, quantity: 1 }];
        var ob = bladeOffer(s.pack, false);
        if (ob && ob.variant && ob.variant.id) onceItems.push({ id: ob.variant.id, quantity: 1 });
        cart.add(onceItems); return;
      }
      var b = R.offer(s.grip, s.pack, true, s.rhythm);
      var bundle = 'rz' + Date.now().toString(36);
      var items = [{ id: kv.id, quantity: 1, properties: { _rz_bundle: bundle } }];
      if (b && b.variant.id) {
        var it = { id: b.variant.id, quantity: 1, properties: { _rz_bundle: bundle } };
        if (b.plan && b.plan.id) it.selling_plan = b.plan.id;
        items.push(it);
      }
      cart.add(items);
    };
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-rz-act]'))) {
        var a = t.getAttribute('data-rz-act');
        if (a === 'abo') { s.mode = 'abo'; go(s.step); }
        else if (a === 'toggle-mode') { s.mode = s.mode === 'abo' ? 'once' : 'abo'; go(s.step); }
        else if (a === 'next1') go(1);
        else if (a === 'next2') go(2);
        else if (a === 'edit') go(Number(t.getAttribute('data-step')));
        else if (a === 'add') self.add();
        return;
      }
      if ((t = e.target.closest('[data-rz-rhythm]'))) { s.rhythm = Number(t.getAttribute('data-rz-rhythm')); update(); return; }
      if ((t = e.target.closest('[data-rz-pack]'))) { s.pack = Number(t.getAttribute('data-rz-pack')); update(); return; }
      if ((t = e.target.closest('[data-rz-grip]'))) { s.grip = t.getAttribute('data-rz-grip').toLowerCase(); update(); }
    });
    $$('[data-rz-kit-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (root._wizardDone === false) { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        self.add();
      });
    });
    update();
  }

  /* ============================================================== Refills */
  function RefillsPicker(root) {
    // Seite gehört zu den Theme-Refills (face/body getrennt oder kombiniert) → gemeinsames Modell, sonst nur dieses Produkt
    var pageData = readData('rz-data-refills-page');
    var Rg = RZ.refills();
    var R = (!pageData || inList(RZ.refillsHandles, pageData.handle)) ? Rg : readProduct('rz-data-refills-page');
    var params = new URLSearchParams(window.location.search);
    var cfg = root.dataset;
    var packs = R.packs();
    var s = {
      grip: (params.get('grip') || cfg.defaultGrip || 'face').toLowerCase(),
      pack: Number(params.get('pack') || cfg.defaultPack || 20),
      mode: cfg.subFirst === 'false' ? 'once' : 'abo',
      rhythm: Number(params.get('rhythm') || RZ.defaultRhythm || 3)
    };
    if (params.get('variant')) {
      var pv = R.variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0];
      if (pv) {
        if (R.gripIdx >= 0) s.grip = pv.options[R.gripIdx].toLowerCase();
        if (R.packIdx >= 0) s.pack = parseInt(pv.options[R.packIdx].match(/\d+/)[0], 10);
      }
    }
    if (packs.length && !packs.some(function (p) { return p.n === s.pack; })) s.pack = packs[packs.length - 1].n;
    var max = packs.length ? packs[packs.length - 1].n : 20;
    var min = packs.length ? packs[0].n : 5;
    var hasPlans = R.months().length > 0 && !RZ.aboOnlyKit;
    if (RZ.aboOnlyKit) s.mode = 'once';
    var badgesOnlyAbo = cfg.badgesOnlyAbo !== 'false';

    function update() {
      var abo = s.mode === 'abo' && (hasPlans || R.data.demo);
      var o = R.offer(s.grip, s.pack, abo, s.rhythm);
      if (!o) return;
      var base = R.offer(s.grip, min, abo, s.rhythm);
      setText(root, 'ref-grip', s.grip);
      setText(document, 'ref-grip', s.grip);
      setText(root, 'ref-per', perBlade(o.price, s.pack));
      setText(root, 'ref-count', s.pack);
      setText(root, 'ref-price', eur(o.price));
      setText(root, 'ref-strike', eur(o.reg));
      setShow(root, 'ref-save', abo && o.reg > o.price);
      var vol = base ? Math.round(base.price * (s.pack / min)) - o.price : 0;
      setShow(root, 'ref-vol', abo && s.pack !== min && vol > 0);
      setText(root, 'ref-vol', 'Du sparst ' + eur(vol) + ' gegenüber ' + (s.pack / min) + ' × ' + min + 'er');
      var top = R.offer(s.grip, max, abo, s.rhythm);
      var more = top ? Math.round(o.price * (max / s.pack)) - top.price : 0;
      setShow(root, 'ref-upsell', s.pack !== max && more > 0);
      setText(root, 'ref-upsell', 'Für dieselben ' + max + ' Klingen zahlst du so ' + eur(more) + ' mehr.');
      setText(root, 'ref-upsell-btn', '→ ' + max + 'er wählen');
      var cta = abo ? 'Abo starten' : 'In den Warenkorb';
      setText(document, 'ref-cta', cta);
      setText(document, 'ref-pack-label', s.pack + 'er');
      setText(document, 'ref-per', perBlade(o.price, s.pack));
      setText(document, 'ref-price', eur(o.price));
      $$('[data-rz-badge]', root).forEach(function (el) { el.hidden = badgesOnlyAbo && !abo; });
      $$('[data-rz-grip]', root).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-rz-grip').toLowerCase() === s.grip); });
      $$('[data-rz-pack]', root).forEach(function (el) { el.classList.toggle('is-active', Number(el.getAttribute('data-rz-pack')) === s.pack); });
      $$('[data-rz-mode]', root).forEach(function (el) { el.classList.toggle('is-active', (el.getAttribute('data-rz-mode') === 'abo') === abo); });
      $$('[data-rz-grip-show]').forEach(function (el) { el.hidden = el.getAttribute('data-rz-grip-show') !== s.grip; });
      // Sticky
      setText(document, 'sticky-name', s.grip + ' refills');
      setText(document, 'sticky-meta', s.pack + 'er · ' + (abo ? 'im Abo' : 'einmalig'));
      setText(document, 'sticky-per', perBlade(o.price, s.pack) + ' pro Klinge');
      setText(document, 'sticky-total-label', abo ? 'Je Lieferung' : 'Einmalig');
      setText(document, 'sticky-total', eur(o.price));
      setText(document, 'sticky-cta', cta);
      var sImg = $('[data-rz-sticky-img]');
      if (sImg) sImg.src = s.grip === 'body' ? sImg.getAttribute('data-body') : sImg.getAttribute('data-face');
      if (o.variant.id && window.history.replaceState) {
        var u = new URL(o.variant.productUrl || window.location.href, window.location.origin);
        u.searchParams.set('variant', o.variant.id); window.history.replaceState({}, '', u.pathname + u.search);
      }
      root._offer = o;
    }
    function add() {
      var o = root._offer;
      if (!o || !o.variant.id) { cart.add([{ id: null }]); return; }
      var it = { id: o.variant.id, quantity: 1 };
      if (o.plan && o.plan.id) it.selling_plan = o.plan.id;
      cart.add([it]);
    }
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-rz-grip]'))) { s.grip = t.getAttribute('data-rz-grip').toLowerCase(); update(); }
      else if ((t = e.target.closest('[data-rz-pack]'))) { s.pack = Number(t.getAttribute('data-rz-pack')); update(); }
      else if ((t = e.target.closest('[data-rz-mode]'))) { s.mode = t.getAttribute('data-rz-mode'); update(); }
      else if (e.target.closest('[data-rz-act="max"]')) { s.pack = max; update(); }
      else if (e.target.closest('[data-rz-act="add"]')) add();
    });
    $$('[data-rz-ref-add]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); add(); }); });
    update();
  }

  /* ================================================== Refills-Wizard
     Wie der Starterkit-Wizard, nur ohne Kit: 01 Kaufart · 02 Klingen · 03 Rhythmus (nur im Abo).
     In den Warenkorb kommt nur das Refill (im Abo mit Selling Plan). */
  function RefillsWizard(root) {
    var pageData = readData('rz-data-refills-page');
    var R = (!pageData || inList(RZ.refillsHandles, (RZ.refills(), pageData.handle))) ? RZ.refills() : readProduct('rz-data-refills-page');
    var params = new URLSearchParams(window.location.search);
    var cfg = root.dataset;
    var packs = R.packs();
    var hasPlans = (R.months().length > 0 || R.data.demo) && cfg.aboOnlyKit !== 'true' && cfg.hasPlans !== 'false';
    var months = R.months().length ? R.months() : DEMO_MONTHS;
    var s = {
      // face und body haben eigene Seiten: es gilt die Variante der Seite
      grip: (cfg.defaultGrip || 'face').toLowerCase(),
      mode: hasPlans && cfg.subFirst !== 'false' ? 'abo' : 'once',
      pack: Number(params.get('pack') || cfg.defaultPack || 10),
      rhythm: Number(params.get('rhythm') || RZ.defaultRhythm || 3),
      step: 0
    };
    if (params.get('variant')) {
      var pv = R.variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0];
      if (pv && R.packIdx >= 0) s.pack = parseInt(pv.options[R.packIdx].match(/\d+/)[0], 10);
    }
    if (months.indexOf(s.rhythm) < 0) s.rhythm = months[Math.min(1, months.length - 1)];
    if (packs.length && !packs.some(function (p) { return p.n === s.pack; })) s.pack = packs[Math.min(1, packs.length - 1)].n;
    var popular = Number(cfg.popularPack || 10);
    var self = this;

    var pills = $('[data-rz-rhythms]', root);
    if (pills) {
      pills.innerHTML = months.map(function (m) {
        return '<button type="button" class="rz-chip-sm" data-rz-rhythm="' + m + '">' + rhythmLabel(m) + '</button>';
      }).join('');
    }
    var grid = $('[data-rz-packgrid]', root);
    function renderPacks(abo) {
      if (!grid || !packs.length) return;
      var base = R.offer(s.grip, packs[0].n, abo, s.rhythm);
      grid.innerHTML = packs.map(function (p) {
        var o = R.offer(s.grip, p.n, abo, s.rhythm);
        if (!o) return '';
        var per = o.price / p.n;
        var pct = base ? Math.round((1 - per / (base.price / packs[0].n)) * 100) : 0;
        var cls = 'rz-pack' + (p.n === popular ? ' is-popular' : '') + (p.n === s.pack ? ' is-active' : '');
        return '<button type="button" class="' + cls + '" data-rz-pack="' + p.n + '">'
          + (p.n === popular ? '<span style="position:absolute;top:-11px;left:16px;background:var(--rz-btn);color:var(--rz-btn-text);font-size:11px;font-weight:500;padding:4px 10px;border-radius:999px">Empfohlen</span>' : '')
          + '<span style="font-size:15px;font-weight:500">' + p.n + 'er</span>'
          + '<span style="display:flex;align-items:baseline;gap:8px;margin-top:10px;flex-wrap:wrap"><span style="font-size:18px;font-weight:500;white-space:nowrap">' + eur(o.price) + '</span>'
          + (o.reg > o.price ? '<span style="font-size:13px;color:var(--rz-muted);text-decoration:line-through;white-space:nowrap">' + eur(o.reg) + '</span>' : '') + '</span>'
          + '<span style="display:block;margin-top:4px;font-size:12px;color:var(--rz-muted);white-space:nowrap">' + perBlade(o.price, p.n) + ' pro Klinge'
          + (pct > 0 ? ' <span style="font-weight:500;color:var(--rz-positive)">−' + pct + ' %</span>' : '') + '</span></button>';
      }).join('');
    }
    function update() {
      var abo = s.mode === 'abo' && hasPlans;
      var o = R.offer(s.grip, s.pack, abo, s.rhythm);
      if (!o) return;
      // Kaufart-Karte: günstigster Klingenpreis im Abo, Ersparnis bis zu … %, Einmalpreis ab …
      var minAboPer = 0, minOnce = 0, maxPct = 0;
      packs.forEach(function (p) {
        var a = R.offer(s.grip, p.n, true, s.rhythm), e = R.offer(s.grip, p.n, false);
        if (a && (!minAboPer || a.price / p.n < minAboPer)) minAboPer = a.price / p.n;
        if (e && (!minOnce || e.price < minOnce)) minOnce = e.price;
        if (a && e && e.price > a.price) maxPct = Math.max(maxPct, Math.round((1 - a.price / e.price) * 100));
      });
      root.classList.toggle('is-abo', abo);
      if (minAboPer) setText(root, 'ref-abo-from', 'ab ' + eur(Math.round(minAboPer)));
      setText(root, 'ref-save', 'Du sparst bis zu ' + maxPct + ' %');
      setShow(root, 'ref-save', maxPct > 0);
      setText(root, 'ref-once-label', abo ? 'oder einmalig kaufen (ab ' + eur(minOnce) + ')' : 'zurück zum Abo');
      setText(root, 's1-summary', abo ? 'Im Abo' : 'Einmaliger Kauf');
      setText(root, 's2-summary', s.pack + 'er · ' + eur(o.price));
      setText(root, 's3-summary', rhythmLabel(s.rhythm));
      setText(root, 'ref-line-label', s.grip + ' Refill ' + s.pack + 'er');
      setText(root, 'ref-line-price', eur(o.price));
      setText(root, 'ref-line-per', perBlade(o.price, s.pack));
      setText(root, 'ref-line-total', eur(o.price));
      setText(root, 'ref-recurring', 'Danach ' + rhythmLabel(s.rhythm) + ' ' + eur(o.price) + ' für ' + s.pack + ' Klingen. Jederzeit pausieren oder kündigen.');
      var sub = $('[data-rz-subcard]', root); if (sub) sub.classList.toggle('is-dim', !abo);
      var ol = $('[data-rz-oncelink]', root); if (ol) ol.classList.toggle('is-active', !abo);

      // Schritte: einmalig endet nach 02 Klingen, im Abo nach 03 Rhythmus
      var last = abo ? 2 : 1;
      $$('[data-rz-step]', root).forEach(function (el) {
        var i = Number(el.getAttribute('data-rz-step'));
        el.classList.toggle('is-done', s.step > i);
        el.hidden = i > last || (i > 0 && s.step < i);
        var num = $('.rz-step-num', el);
        if (num) num.textContent = s.step > i ? '✓' : ('0' + (i + 1));
      });
      $$('[data-rz-act="next2"]', root).forEach(function (b) { b.hidden = !abo; });
      $$('[data-rz-dot]', root).forEach(function (el) {
        var i = Number(el.getAttribute('data-rz-dot'));
        el.hidden = i > last;
        el.style.background = (i === 0 || s.step >= i) ? 'var(--rz-text)' : 'rgb(var(--rz-text-rgb) / 0.15)';
      });
      $$('[data-rz-rhythm]', root).forEach(function (el) { el.classList.toggle('is-active', Number(el.getAttribute('data-rz-rhythm')) === s.rhythm); });
      renderPacks(abo);

      var done = s.step >= last;
      root._wizardDone = done;
      $$('[data-rz-act="add"]', root).forEach(function (b) { b.hidden = !done; });
      var cta = abo ? 'Abo starten' : 'In den Warenkorb';
      setText(document, 'ref-cta', cta);
      // Sticky
      var perTxt = s.step >= 1 || !minAboPer ? perBlade(o.price, s.pack) : 'ab ' + eur(Math.round(minAboPer));
      setText(document, 'sticky-name', s.grip + ' refills');
      setText(document, 'sticky-meta', (s.step >= 1 ? s.pack + 'er · ' : '') + (abo ? 'im Abo' : 'einmalig'));
      setText(document, 'sticky-per', perTxt + ' pro Klinge');
      setText(document, 'sticky-total-label', abo ? 'Je Lieferung' : 'Einmalig');
      setText(document, 'sticky-total', eur(o.price));
      setText(document, 'sticky-cta', done ? cta : 'Weiter zur Auswahl');
      var sImg = $('[data-rz-sticky-img]');
      if (sImg) sImg.src = s.grip === 'body' ? sImg.getAttribute('data-body') : sImg.getAttribute('data-face');
      if (o.variant.id && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', o.variant.id); window.history.replaceState({}, '', u.toString());
      }
      root._offer = o;
    }
    function go(i) { s.step = Math.min(i, s.mode === 'abo' && hasPlans ? 2 : 1); update(); }
    this.add = function () {
      var o = root._offer;
      if (!o || !o.variant.id) { cart.add([{ id: null }]); return; }
      var it = { id: o.variant.id, quantity: 1 };
      if (s.mode === 'abo' && hasPlans && o.plan && o.plan.id) it.selling_plan = o.plan.id;
      cart.add([it]);
    };
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-rz-act]'))) {
        var a = t.getAttribute('data-rz-act');
        if (a === 'abo') { if (hasPlans) { s.mode = 'abo'; go(s.step); } }
        else if (a === 'toggle-mode') { if (hasPlans) { s.mode = s.mode === 'abo' ? 'once' : 'abo'; go(s.step); } }
        else if (a === 'next1') go(1);
        else if (a === 'next2') go(2);
        else if (a === 'edit') go(Number(t.getAttribute('data-step')));
        else if (a === 'add') self.add();
        return;
      }
      if ((t = e.target.closest('[data-rz-rhythm]'))) { s.rhythm = Number(t.getAttribute('data-rz-rhythm')); update(); return; }
      if ((t = e.target.closest('[data-rz-pack]'))) { s.pack = Number(t.getAttribute('data-rz-pack')); update(); }
    });
    $$('[data-rz-ref-add]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); self.add(); }); });
    update();
  }

  /* ===================================================== Preistabellen */
  function PriceTable(root) {
    var R = RZ.refills(); if (R.data.demo) return;
    var RA = RZ.abo();
    var grip = (root.getAttribute('data-grip') || 'face');
    var rhythm = Number(RZ.defaultRhythm || 3);
    var packs = R.packs(); if (!packs.length) return;
    var tbody = $('tbody', root);
    var maxRegPer = 0, minAboPer = Infinity;
    tbody.innerHTML = packs.map(function (p) {
      var once = R.offer(grip, p.n, false), abo = RA.offer(grip, p.n, true, rhythm) || once;
      maxRegPer = Math.max(maxRegPer, once.reg / p.n);
      minAboPer = Math.min(minAboPer, abo.price / p.n);
      var td = 'border-top:1px solid rgb(var(--rz-text-rgb) / 0.12)';
      return '<tr><td style="font-size:19px;padding:18px 0;' + td + '">' + p.n + 'er</td>'
        + '<td style="font-size:17px;text-align:right;color:var(--rz-muted);padding:18px 0;' + td + '">' + eur(once.reg) + '</td>'
        + '<td style="font-size:17px;text-align:right;color:var(--rz-muted);padding:18px 0;' + td + '">' + perBlade(once.reg, p.n) + '</td>'
        + '<td style="font-size:19px;font-weight:500;text-align:right;padding:18px 24px;' + td + ';background:var(--rz-bg)">' + eur(abo.price) + '</td>'
        + '<td style="font-size:19px;font-weight:500;text-align:right;padding:18px 0;' + td + ';background:var(--rz-bg)">' + perBlade(abo.price, p.n) + '</td></tr>';
    }).join('');
    var note = $('[data-rz-t="table-note"]', root);
    if (note) {
      var top = packs[packs.length - 1].n;
      var topOnce = R.offer(grip, top, false), topAbo = RA.offer(grip, top, true, rhythm) || topOnce;
      note.textContent = 'Im Abo zahlst du pro Klinge bis zu ' + eur(Math.round(maxRegPer - minAboPer)) + ' weniger. Das sind bei der ' + top + 'er-Packung ' + eur(topOnce.reg - topAbo.price) + ' pro Lieferung.';
    }
  }

  /* ====================================================== Abo-Rechner */
  function AboCalc(root) {
    var K = RZ.kit(), R = RZ.abo();
    var months = R.months().length ? R.months() : DEMO_MONTHS;
    var packs = R.packs().length ? R.packs() : [{ n: 5 }, { n: 10 }, { n: 20 }];
    var grip = root.getAttribute('data-grip') || 'face';
    var s = { pack: Number(root.getAttribute('data-default-pack') || 10), rhythm: Number(RZ.defaultRhythm || 3) };
    if (months.indexOf(s.rhythm) < 0) s.rhythm = months[0];
    var kitV = K.find({ grip: grip, abo: K.modeIdx >= 0 ? true : null }) || K.variants[0];
    var kitAbo = kitV ? kitAboPrice(K, kitV) : 999;
    var cards = $('[data-rz-abo-cards]', root);
    var chips = $('[data-rz-rhythms]', root);
    if (chips && R.months().length) {
      chips.innerHTML = months.map(function (m) { return '<button type="button" class="rz-chip" data-rz-rhythm="' + m + '">' + (function (l) { return l.charAt(0).toUpperCase() + l.slice(1); })(rhythmLabel(m)) + '</button>'; }).join('');
    }
    function update() {
      if (cards && !R.data.demo) {
        cards.innerHTML = packs.map(function (p) {
          var o = R.offer(grip, p.n, true, s.rhythm); if (!o) return '';
          var l = function (a, b, st) { return '<div style="display:flex;justify-content:space-between;' + (st || 'font-size:16px') + '"><span>' + a + '</span><span>' + b + '</span></div>'; };
          return '<button type="button" class="rz-opt' + (p.n === s.pack ? ' is-active' : '') + '" data-rz-pack="' + p.n + '">'
            + '<div style="font-size:24px;font-weight:500">' + p.n + 'er</div>'
            + '<div style="margin-top:22px;display:flex;flex-direction:column;gap:12px">'
            + l('Starterkit', eur(kitAbo)) + l('Klingen', eur(o.price))
            + l('Erste Lieferung', eur(kitAbo + o.price), 'font-size:17px;font-weight:500;border-top:1px solid rgb(var(--rz-text-rgb) / 0.15);padding-top:12px')
            + l('Danach je Lieferung', eur(o.price), 'font-size:16px;color:var(--rz-muted)')
            + l('pro Klinge', perBlade(o.price, p.n), 'font-size:16px;color:var(--rz-muted)')
            + '</div></button>';
        }).join('');
      } else {
        $$('[data-rz-pack]', root).forEach(function (el) { el.classList.toggle('is-active', Number(el.getAttribute('data-rz-pack')) === s.pack); });
      }
      $$('[data-rz-rhythm]', root).forEach(function (el) { el.classList.toggle('is-active', Number(el.getAttribute('data-rz-rhythm')) === s.rhythm); });
      var o = R.offer(grip, s.pack, true, s.rhythm);
      var first = kitAbo + (o ? o.price : 0);
      setText(root, 'abo-cta', 'Weiter mit ' + s.pack + 'er — ' + eur(first));
      var link = $('[data-rz-abo-link]', root);
      if (link) {
        var u = new URL(link.getAttribute('data-base') || RZ.urls.kit, window.location.origin);
        u.searchParams.set('pack', s.pack); u.searchParams.set('rhythm', s.rhythm); u.searchParams.set('grip', grip);
        link.href = u.pathname + u.search;
      }
      setText(document, 'sticky-name', 'razeco5 starterkit');
      setText(document, 'sticky-meta', s.pack + 'er · im Abo');
      setText(document, 'sticky-per', o ? perBlade(o.price, s.pack) + ' pro Klinge' : '');
      setText(document, 'sticky-total-label', 'Erste Lieferung');
      setText(document, 'sticky-total', eur(first));
    }
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-rz-pack]'))) { s.pack = Number(t.getAttribute('data-rz-pack')); update(); }
      else if ((t = e.target.closest('[data-rz-rhythm]'))) { s.rhythm = Number(t.getAttribute('data-rz-rhythm')); update(); }
    });
    update();
  }

  /* ============================================ Schnellkauf (Startseite) */
  // Kit direkt in den Warenkorb: mit Klingen-Abo (Standardpackung + Standardrhythmus) oder einmalig.
  function quickKit(grip, mode) {
    var K = RZ.kit(), R = RZ.abo();
    var abo = mode !== 'once';
    var kv = K.find({ grip: grip, abo: K.modeIdx >= 0 ? abo : null });
    if (!kv || !kv.id) { cart.add([{ id: null }]); return; }
    if (!abo) { cart.add([{ id: kv.id, quantity: 1 }]); return; }
    var packs = R.packs();
    var pack = (packs.filter(function (p) { return p.n === 10; })[0] || packs[Math.floor(packs.length / 2)] || { n: 10 }).n;
    var b = R.offer(grip, pack, true, Number(RZ.defaultRhythm || 3));
    var bundle = 'rz' + Date.now().toString(36);
    var items = [{ id: kv.id, quantity: 1, properties: { _rz_bundle: bundle } }];
    if (b && b.variant.id) {
      var it = { id: b.variant.id, quantity: 1, properties: { _rz_bundle: bundle } };
      if (b.plan && b.plan.id) it.selling_plan = b.plan.id;
      items.push(it);
    }
    cart.add(items);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rzh-quick-kit]');
    if (!t) return;
    e.preventDefault();
    quickKit(t.getAttribute('data-rzh-quick-kit'), t.getAttribute('data-mode'));
  });

  /* ============================================================ Diverses */
  function initMenu() {
    var btn = $('[data-rz-menu-toggle]'), menu = $('[data-rz-mobile-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () {
      var open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open);
      btn.textContent = open ? 'schließen' : 'menü';
    });
  }
  function initChoice(root) { // Griff-Check (Passt es?)
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rz-choice]'); if (!t) return;
      var v = t.getAttribute('data-rz-choice');
      $$('[data-rz-choice]', root).forEach(function (el) { el.classList.toggle('is-active', el === t); });
      $$('[data-rz-result]', root).forEach(function (el) {
        var r = el.getAttribute('data-rz-result');
        if (r === 'none') el.hidden = true;
        else if (r === 'unsure') el.hidden = v !== 'unsure';
        else el.hidden = v === 'unsure';
      });
    });
  }
  function initTabs(root) { // FAQ-Tabs
    function show(tab) {
      $$('[data-rz-tab]', root).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-rz-tab') === tab); });
      $$('[data-rz-tab-item]', root).forEach(function (el) { el.hidden = el.getAttribute('data-rz-tab-item') !== tab; });
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rz-tab]'); if (t) show(t.getAttribute('data-rz-tab'));
    });
    var first = $('[data-rz-tab]', root); if (first) show(first.getAttribute('data-rz-tab'));
  }
  function initLightbox() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-rz-lightbox-open]');
      if (o) {
        var box = document.getElementById(o.getAttribute('data-rz-lightbox-open'));
        if (box) { e.preventDefault(); box.hidden = false; lock(true); var v = $('video', box); if (v) v.play(); }
        return;
      }
      var c = e.target.closest('[data-rz-lightbox-close]');
      if (c) { e.preventDefault(); closeBox(c.closest('[data-rz-lightbox]')); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-rz-lightbox]').forEach(function (b) { if (!b.hidden) closeBox(b); });
    });
    function closeBox(box) {
      if (!box || box.hidden) return;
      box.hidden = true; lock(false);
      var v = $('video', box); if (v) v.pause();
      var f = $('iframe', box); if (f) { var src = f.src; f.src = ''; f.src = src; }
    }
  }

  // Mobil: Punkte unter der Wisch-Galerie
  function initGallery(g) {
    var items = $$(':scope > div:not([data-rz-gallery-sub]):not([data-rz-gallery-ph]), [data-rz-gallery-sub] > div', g);
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.setAttribute('data-rz-dots', '');
    dots.setAttribute('aria-hidden', 'true');
    items.forEach(function (_, i) { var s = document.createElement('span'); if (!i) s.className = 'is-on'; dots.appendChild(s); });
    g.parentNode.insertBefore(dots, g.nextSibling);
    var tick = null;
    g.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = null;
        var mid = g.scrollLeft + g.clientWidth / 2, best = 0, dist = 1e9;
        items.forEach(function (it, i) { var c = it.offsetLeft + it.offsetWidth / 2; var d = Math.abs(c - mid); if (d < dist) { dist = d; best = i; } });
        $$('span', dots).forEach(function (s, i) { s.classList.toggle('is-on', i === best); });
      });
    }, { passive: true });
  }
  function boot() {
    $$('select[data-default]').forEach(function (sel) { if (sel.getAttribute('data-default')) sel.value = sel.getAttribute('data-default'); });
    initMenu();
    initLightbox();
    cart.init();
    $$('[data-rz-kit]').forEach(function (r) { new KitWizard(r); });
    $$('[data-rz-refills]').forEach(function (r) { new RefillsPicker(r); });
    $$('[data-rz-refwiz]').forEach(function (r) { new RefillsWizard(r); });
    $$('[data-rz-pricetable]').forEach(function (r) { new PriceTable(r); });
    $$('[data-rz-abo]').forEach(function (r) { new AboCalc(r); });
    $$('[data-rz-choices]').forEach(initChoice);
    $$('[data-rz-tabs]').forEach(initTabs);
    $$('[data-rz-sticky-root]').forEach(function (r) { new Sticky(r); });
    $$('[data-rz-gallery]').forEach(initGallery);
    renderDelivery();
    setInterval(renderDelivery, 60000);
    // Sticky-CTA → Hauptaktion
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rz-sticky-cta]'); if (!t) return;
      var target = t.getAttribute('data-rz-sticky-cta');
      if (target === 'scroll') return; // normaler Anker
      e.preventDefault();
      // Wizard noch nicht fertig: zur Auswahl scrollen statt direkt in den Warenkorb
      var kitRoot = $('[data-rz-kit], [data-rz-refwiz]');
      if (kitRoot && kitRoot._wizardDone === false) { kitRoot.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var btn = $('[data-rz-kit] [data-rz-act="add"], [data-rz-refills] [data-rz-act="add"], [data-rz-refwiz] [data-rz-act="add"]');
      if (btn) btn.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
